import { useState } from 'react'
import toast from 'react-hot-toast'
import Modal from '../../ui/Modal'
import { deliveriesAPI } from '../../../api/deliveries'

const RETARD_REASONS = [
  'Embouteillages',
  'Problème de navigation',
  'Problème de véhicule',
  "Difficultés à trouver l'adresse",
  'Autre',
]

const labelStyle: React.CSSProperties = {
  display: 'block', fontSize: 13,
  fontWeight: 600, color: '#374151', marginBottom: 8,
}

const textareaStyle: React.CSSProperties = {
  width: '100%', padding: '12px 14px',
  borderRadius: 12, border: '1.5px solid #E5E7EB',
  fontSize: 14, fontFamily: "'DM Sans', sans-serif",
  resize: 'vertical', outline: 'none',
  background: '#FAFAFA', color: '#0D1117',
  boxSizing: 'border-box',
}

const btnStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 8,
  border: 'none', borderRadius: 12,
  padding: '12px 20px', color: '#fff',
  fontSize: 14, fontWeight: 600,
  cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  flex: 1, justifyContent: 'center',
}

interface RetardModalProps {
  deliveryId: string
  onClose: () => void
  onSuccess: () => void
}

export const RetardModal = ({ deliveryId, onClose, onSuccess }: RetardModalProps) => {
  const [reason, setReason] = useState('')
  const [comment, setComment] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async () => {
    if (!reason) return
    setIsLoading(true)
    try {
      const note = comment.trim()
        ? `RETARD — ${reason} : ${comment}`
        : `RETARD — ${reason}`
      await deliveriesAPI.addComment(deliveryId, note)
      toast.success('Retard signalé')
      onSuccess()
      onClose()
    } catch {
      toast.error('Erreur lors du signalement')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal open title="Signaler un retard" onClose={onClose} size="sm">
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Raison du retard *</label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {RETARD_REASONS.map((r) => (
            <label key={r} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '10px 14px', borderRadius: 10,
              border: `1px solid ${reason === r ? '#F59E0B' : '#E5E7EB'}`,
              background: reason === r ? '#FFFBEB' : '#fff',
              cursor: 'pointer', fontSize: 14,
            }}>
              <input
                type="radio" name="retardReason" value={r}
                checked={reason === r}
                onChange={() => setReason(r)}
                style={{ accentColor: '#F59E0B' }}
              />
              {r}
            </label>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Commentaire (optionnel)</label>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Précisez si nécessaire..."
          rows={3} maxLength={300}
          style={textareaStyle}
        />
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onClose} style={{ ...btnStyle, background: '#F3F4F6', color: '#374151' }}>
          Annuler
        </button>
        <button
          onClick={handleSubmit}
          disabled={!reason || isLoading}
          style={{ ...btnStyle, background: '#F59E0B', opacity: (!reason || isLoading) ? 0.7 : 1, cursor: (!reason || isLoading) ? 'not-allowed' : 'pointer' }}
        >
          {isLoading ? 'Envoi...' : 'Signaler le retard'}
        </button>
      </div>
    </Modal>
  )
}
